function plugin(Vue, options = {}) {
  Object.defineProperties(Vue.prototype, {
    $breadcrumbs: {
      get: function () {

        var crumbs = []
        for (var i = 0; i < this.$route.matched.length; i++) {

          var crumb = this.$route.matched[i].meta.breadcrumb
          var display_name = crumb != undefined && typeof crumb === 'string' && crumb.startsWith('#') ? "" + crumb + this.$route.params.id : crumbs

          if (crumb != undefined && crumb.startsWith('#')) {
            crumb = display_name
          }
          crumbs.push({
            display_name: crumb,
            route_name: this.$route.matched[i].name,
            route_path: this.$route.matched[i].path + '/'
          })

        }
        return crumbs
      }
    },
  })

  Vue.prototype.$breadcrumbsTarget = function (item) {
    if (item.route_name) {
      return {name: item.route_name};
    } else {
      if (item.route_path.indexOf(":") !== -1) {
        return {path: item.route_path.replace(/:[a-z]+/, this.$route.params.id)}
      } else {
        return {path: item.route_path}
      }

    }
  },

    Vue.component('breadcrumbs', {
      template: '<div class="row">' +
      '<nav aria-label="You are here:" role="navigation" v-if="$breadcrumbs.length">' +
      '<ul class="breadcrumbs">' +
      '<li v-for="(crumb, index) in $breadcrumbs">' +
      '<router-link :to="$breadcrumbsTarget(crumb)">{{ crumb.display_name }}</router-link>' +
      '</li>' +
      '</ul>' +
      '</nav>' +
      '</div>'
    })
}

plugin.version = '0.3.0'

export default plugin



// WEBPACK FOOTER //
// ./src/lib/plugins/breadcrumbs.js